import { getUniversalBackendHost } from 'app/lib/get-universal-backend-host';
import { getUniversalEnv } from 'app/lib/get-universal-env';
import { ValueOf } from 'app/types/tsHelpers';

const isDevelopment = getUniversalEnv('NODE_ENV') === 'development';
const CDN_STATIC = getUniversalEnv('CDN_STATIC');
const backendServerUrl = `${getUniversalEnv('BACKEND_SERVER_PROTOCOL')}://${getUniversalBackendHost()}`;

export const URL_TYPE = {
  PUBLIC: 'public',
};

export const getUniversalUrl = (url: string, type?: ValueOf<typeof URL_TYPE>): string => {
  const urlWithoutFirstSlash = url.startsWith('/') ? url.slice(1): url;
  const isUrl = url.startsWith('http://') || url.startsWith('https://');

  if (isUrl) {
    return url;
  }

  if (isDevelopment || !CDN_STATIC) {
    return `/${urlWithoutFirstSlash}`;
  }

  if (type === URL_TYPE.PUBLIC) {
    return `${CDN_STATIC}/${URL_TYPE.PUBLIC}/${urlWithoutFirstSlash}`;
  }

  return `${backendServerUrl}/${urlWithoutFirstSlash}`;
};
